import React from 'react';
import graph from '../graph';
import Update from '../Update';
import Delete from '../Delete';
import Control from './Control';
import AssignUser from './AssignUser';
import AssignProduct from './AssignProduct';
import ReadyCouponRequest from './Control/Content/ReadyCouponRequest';

import jMoment from 'moment-jalaali';
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded';

import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';
import { addCommas, digitsFaToEn } from '@persian-tools/persian-tools';
import { Fade, Card, Stack, Typography, CardHeader, CardActions, CardActionArea, Avatar, CardContent, Box, alpha, Button } from '@mui/material';
import UserStatistics from './UserStatistics';
import CheckMessages from './CheckMessages';

function statuses(status) {
  switch (status) {
    case "REGISTERED":
      return ({title: 'ثبت اولیه', color: 'action.selected'})
    case "PENDING":
      return { title: 'در حال بررسی', color: 'warning.main' };
    case "RELEASED":
      return { title: 'منتشر شده', color: 'success.main' };
    default:
      return { title: 'غیرفعال', color: 'error.main' };
  }
}

export default function Model({ model, delay, checked, refetch, isAssign, selectable, handleSelect }) {
  const {
    id,
    title,
    amount,
    media,
    shop,
    users,
    status,
    check_messages,
    assignment_type,
    products_shop,
    product_categories,
    is_active,
    start_date,
    end_date,
  } = model;
  const { roles } = useSelector((state) => state.auth.userInfo);
  const isAdmin = hasRequiredRole(['unitManager'], roles);

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              borderColor: checked && 'primary.main',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <Avatar sx={{ height: 28, width: 28, fontSize: 18, bgcolor: 'action.selected' }}>
                  <BookmarkRoundedIcon fontSize="inherit" color="primary" />
                </Avatar>
              }
              // avatar={
              //   <NewMediaPopup id={id} model="Booth" collection="avatar" title={title} graph={graph}>
              //     <AvatarPopover isAssign={isAssign} sx={{ width: 48, height: 48 }} media={media[0]?.full_url} />
              //   </NewMediaPopup>
              // }
              title={<Typography variant="subtitle2">{title}</Typography>}
              subheader={
                <Typography variant="caption" color="textDisabled">{`هر نفر ${addCommas(
                  Number(amount)
                )} تومان`}</Typography>
              }
              action={
                <Stack rowGap={1}>
                  <Typography
                    px={0.5}
                    borderRadius={0.5}
                    variant="caption"
                    color="warning.darker"
                    bgcolor="warning.lighter"
                  >{`فروشگاه ${shop?.title}`}</Typography>
                  <Typography variant="caption" px={0.5} color="textDisabled">
                    انقضا:
                    <Typography component="span" variant="caption" letterSpacing={0.5}>
                      {digitsFaToEn(jMoment(end_date).format('jYYYY/jMM/jDD'))}
                    </Typography>
                  </Typography>
                </Stack>
              }
            />
            <CardContent sx={{ p: 0 }}>
              {/* <Typography borderRadius={1} width='100%' p={0.5} variant="caption" bgcolor={statuses(status).color}>
                {statuses(status).title}
              </Typography> */}
              <Control id={id} refetch={refetch} />
            </CardContent>
            {isAdmin && (
              <CardActions sx={{ justifyContent: 'flex-end' }}>
                <ReadyCouponRequest
                  id={id}
                  refetch={refetch}
                  disabled={status === 'PENDING' || status === 'RELEASED' || check_messages}
                />
                {check_messages && check_messages.length > 0 && <CheckMessages data={check_messages} />}
                <Box flexGrow={1} />
                {status === 'RELEASED' && <UserStatistics id={id} />}
                {status !== 'RELEASED' && <Update ids={id} refetch={refetch} />}
                {/* <Delete id={id} refetch={refetch} /> */}
                {/* <AssignProduct
                  coupon={id}
                  shop={shop}
                  title={title}
                  type={assignment_type}
                  products={products_shop}
                  categories={product_categories}
                  refetch={refetch}
                  count={products_shop?.length || product_categories?.length}
                />
                <AssignUser coupon={id} refetch={refetch} count={users.length} type={assignment_type} />
                {is_active === 2 && <ReadyCouponRequest coupon={id} refetch={refetch} />} */}
              </CardActions>
            )}
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
            {status === 'PENDING' && (
              <CardActionArea
                sx={{
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 1,
                  position: 'absolute',
                  backdropFilter: 'blur(6px)',
                  WebkitBackdropFilter: 'blur(1px)', // Fix on Mobile
                  backgroundColor: (theme) => alpha(theme.palette.warning.main, 0.25),
                }}
              >
                <Stack p={4} rowGap={2} justifyContent="center" alignItems="center">
                  <Typography variant="subtitle2">{title}</Typography>
                  <Typography variant="caption" color="textDisabled">{`هر نفر ${addCommas(
                    Number(amount)
                  )} تومان`}</Typography>
                  <Typography align="center" variant="subtitle1" color="error.dark">
                    درخواست فعالسازی بن جهت بررسی برای مدیر فروشگاه ارسال شده است.
                  </Typography>
                  {isAdmin && <Button size="large" color="error" variant="contained">
                    لغو درخواست
                  </Button>}
                </Stack>
              </CardActionArea>
            )}
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
